import {
  IconButton,
  Button,
  Popover,
  ButtonGroup,
  Modal,
} from "@datapay-by-datacom/design-system";
import { DialogTrigger } from "react-aria-components";
import { useRef, useState } from "react";
import { ThreadRename } from "./ThreadRename";
import { ThreadDelete } from "./ThreadDelete";
import { ThreadSummary } from "../../generated/core-api";

interface ThreadContextMenuProps {
  thread: ThreadSummary;
}

export function ThreadContextMenu({ thread }: ThreadContextMenuProps) {
  const { workspace_id: workspaceId, thread_id: threadId, title } = thread;
  const triggerRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);
  const [renameIsOpen, setRenameIsOpen] = useState(false);
  const [deleteIsOpen, setDeleteIsOpen] = useState(false);

  return (
    <>
      <Modal isOpen={renameIsOpen}>
        <ThreadRename
          threadTitle={title}
          workspaceId={workspaceId}
          threadId={threadId}
          onClose={() => setRenameIsOpen(false)}
        />
      </Modal>

      <Modal isOpen={deleteIsOpen}>
        <ThreadDelete
          workspaceId={workspaceId}
          threadId={threadId}
          onClose={() => setDeleteIsOpen(false)}
        />
      </Modal>

      <IconButton size="small" onPress={() => setIsOpen(true)} ref={triggerRef}>
        ...
      </IconButton>

      <Popover
        triggerRef={triggerRef}
        isOpen={isOpen}
        onOpenChange={setIsOpen}
        placement="right"
      >
        <ButtonGroup>
          <DialogTrigger>
            <Button
              variant="tertiary"
              onPress={() => {
                setRenameIsOpen(true);
                setIsOpen(false);
              }}
            >
              Rename
            </Button>
          </DialogTrigger>
          <Button
            variant="tertiary"
            onPress={() => {
              setDeleteIsOpen(true);
              setIsOpen(false);
            }}
          >
            Delete
          </Button>
        </ButtonGroup>
      </Popover>
    </>
  );
}
